import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './lib/auth';
import LandingPage from './pages/LandingPage';
import EmergencyMode from './pages/EmergencyMode';
import AccidentReportWizard from './pages/AccidentReportWizard';
import PannenhilfePage from './pages/PannenhilfePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CustomerPortal from './pages/CustomerPortal';
import CaseDetailPage from './pages/CaseDetailPage';
import TrackCasePage from './pages/TrackCasePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminCases from './pages/AdminCases';
import AdminCaseDetail from './pages/AdminCaseDetail';
import AdminCustomers from './pages/AdminCustomers';
import AdminVehicles from './pages/AdminVehicles';
import AdminBreakdowns from './pages/AdminBreakdowns';
import AdminDocuments from './pages/AdminDocuments';
import AdminLayout from './components/AdminLayout';
import WhatsAppButton from './components/WhatsAppButton';
import InstallPwaPrompt from './components/InstallPwaPrompt';
import MobileBottomNav from './components/MobileBottomNav';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AdminAuditLogs from './pages/AdminAuditLogs';
import './App.css';

function RequireAuth({ children, role }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="p-6 text-sm text-slate-600">Lade…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role && !(role === 'admin' && user.role === 'staff')) {
    return <Navigate to="/portal" replace />;
  }
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/notfall" element={<EmergencyMode />} />
            <Route path="/unfall-melden" element={<AccidentReportWizard />} />
            <Route path="/pannenhilfe" element={<PannenhilfePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/track" element={<TrackCasePage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route
              path="/portal"
              element={
                <RequireAuth>
                  <CustomerPortal />
                </RequireAuth>
              }
            />
            <Route path="/portal/fall/:caseId" element={<CaseDetailPage />} />
            <Route
              path="/admin"
              element={
                <RequireAuth role="admin">
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="schadenfaelle" element={<AdminCases />} />
              <Route path="schadenfaelle/:caseId" element={<AdminCaseDetail />} />
              <Route path="kunden" element={<AdminCustomers />} />
              <Route path="ersatzfahrzeuge" element={<AdminVehicles />} />
              <Route path="pannenhilfe" element={<AdminBreakdowns />} />
              <Route path="dokumente" element={<AdminDocuments />} />
              <Route path="audit-logs" element={<AdminAuditLogs />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <WhatsAppButton />
          <InstallPwaPrompt />
          <MobileBottomNav />
          <Toaster
            position="top-center"
            richColors
            closeButton
            toastOptions={{ className: 'font-sans' }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
